// extracted by mini-css-extract-plugin
export default {"menuBlock":"UF-z","title":"VF-z","nav":"WF-z","flexCell":"XF-z","facetLink":"YF-z"};